import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { map, Observable, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/store/models/state';
import { selectUser } from 'src/app/core/store/selectors/selectors';
import { AppRoutes } from 'src/app/core/consts/navigation.const';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router,
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.select(selectUser).pipe(
      map((user) => {
        if (user) {
          return true;
        } else {
          this.router.navigate([AppRoutes.LOGIN]);
          return false;
        }
      }),
      take(1),
    );
  }
}
